export default "__VITE_ASSET__BaGNnezo__"